module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JaJkhK/Images/TimeTrapSeries_covers.jpg?1697126297428",
      "alt": "This image is the cover for the book Pieces of Eight, Time Trap"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pieces of Eight, Time Trap\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A swashbuckling pirate adventure in the time travel series from the “masterful” national bestselling author of the Pearls and the Crown novels ("), _c('i', [_vm._v("Extrapolations")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In his attempt to return to the twenty-sixth century, historian and time traveler Noel Kedran is transported back to the Caribbean in 1697, where black-masted ships rule the treacherous seas and murderous pirates kill without mercy."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Stalked by enemies—including his evil twin, Leon—Noel fights to prevent a human sacrifice that could change history, and to stop his twisted twin before he destroys them both for a few glittering, golden pieces of eight."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Chester is a world class fantasist.” —"), _c('i', [_vm._v("The Best Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deborah Chester\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0